import React from 'react';
// import { renderRoutes } from 'react-router-config';
import routes, { AclRoutes } from 'routes';
import useStores from 'stores';

import './App.scss';

function App() {
  const { loginStore } = useStores();
  return (
    <div className="app">
      <AclRoutes
        routes={routes}
        authorities={loginStore.authorities}
      />
    </div>
  ) 
}

export default App;
